enum Language {
  Russian = 'Russian',
  English = 'English',
}

export { Language };
